export default {"src":"/_next/static/media/mochi-coin-color-gray.630886ad.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};